module.exports = __webpack_public_path__ + "static/media/img_publishing.3bdb6e15.jpg";